import React, { useCallback, useEffect, useMemo } from 'react';
import { debounce } from 'lodash';
import { Search, SearchItem, SearchList } from '@naf/search';
import useSelector from '@redux/typedHooks';
import { useFilterAction } from '@utils/bilguide';

const SEARCH_DEBOUNCE_MS = 300;

interface CarSearchProps {
  onSearchSubmit?: (query: string) => void;
}

const CarSearch = ({ onSearchSubmit }: CarSearchProps) => {
  const loading = useSelector((state) => state.cars.isUpdating);
  const mappedData = useSelector((state) => state.cars.mappedData);
  const suggestionIds = useSelector((state) => state.cars.data[0]);
  const suggestions = suggestionIds.map((id) => mappedData[id].data);
  const { applyQuery } = useFilterAction();

  const handleSearchSubmit = useCallback(
    (value: string) => {
      applyQuery(value);
      if (onSearchSubmit) {
        onSearchSubmit(value);
      }
    },
    [applyQuery, onSearchSubmit],
  );

  const debouncedApplyQuery = useMemo(() => debounce(applyQuery, SEARCH_DEBOUNCE_MS), [applyQuery]);

  useEffect(() => () => debouncedApplyQuery.cancel(), [debouncedApplyQuery]);

  return (
    <Search
      placeholder="Bilmerke, bilmodell"
      handleSubmit={handleSearchSubmit}
      handleChange={debouncedApplyQuery}
      handleClear={() => applyQuery('')}
      withButton={false}
    >
      <SearchList loading={loading} empty={suggestions.length <= 0}>
        {suggestions &&
          suggestions.length > 0 &&
          suggestions.map(
            (s: any) =>
              !!s && (
                <SearchItem
                  key={s.id}
                  label={`${s.brandName} ${s.modelName}`}
                  value={s.id}
                  handleClick={(suggestion: { label: string; value: string }) => applyQuery(suggestion.label)}
                />
              ),
          )}
      </SearchList>
    </Search>
  );
};

export default CarSearch;
